(function initSMWDShopifyLogger(global) {
  "use strict";

  /**
   * Represents browser information.
   */
  function Browser(opts) {
    var input = opts || {};
    this.major = input.major || "";
    this.name = input.name || "";
    this.version = input.version || "";
  }

  /**
   * Represents operating system information.
   */
  function OS(opts) {
    var input = opts || {};
    this.name = input.name || "";
  }

  /**
   * Represents device information.
   */
  function Device(opts) {
    var input = opts || {};
    var key;
    for (key in input) {
      if (Object.prototype.hasOwnProperty.call(input, key)) {
        this[key] = input[key];
      }
    }
  }

  /**
   * Represents browser engine information.
   */
  function Engine(opts) {
    var input = opts || {};
    this.name = input.name || "";
    this.version = input.version || "";
  }

  /**
   * Represents CPU information.
   */
  function CPU(opts) {
    var input = opts || {};
    this.architecture = input.architecture || "";
  }

  /**
   * Represents a log entry.
   */
  function Log(opts) {
    var input = opts || {};
    this.id = input.id || 0;
    this.userID = input.userID || "";
    this.sessionID = input.sessionID || "";
    this.logLevel = input.logLevel || "";
    this.event = input.event || "";
    this.createdAt = input.createdAt || 0;
    this.page = input.page || "";
    this.urlParams = input.urlParams || "";
    this.platform = input.platform || "";
    this.messageType = input.messageType || "";
    this.appVersion = input.appVersion || "";
    this.browser =
      input.browser instanceof Browser ? input.browser : new Browser(input.browser);
    this.os = input.os instanceof OS ? input.os : new OS(input.os);
    this.engine =
      input.engine instanceof Engine ? input.engine : new Engine(input.engine);
    this.cpu = input.cpu instanceof CPU ? input.cpu : new CPU(input.cpu);
    this.device =
      input.device instanceof Device ? input.device : new Device(input.device);
      this.device.screen = {
        width: window.screen.width,
        height: window.screen.height,
        availWidth: window.screen.availWidth,
        availHeight: window.screen.availHeight,
      }
    this.data = input.data === undefined ? {} : input.data;

    this.smwdParams = input.smwdParams || {};
  }

  var LOGGER_EVENT_NAME = "smwd:log";
  var LOGGER_USER_ID_KEY = "userID";
  var LOGGER_SESSION_ID_KEY = "sessionID";

  function makeId(length) {
    var len = typeof length === "number" ? length : 32;
    var result = "";
    var characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    var i;

    for (i = 0; i < len; i += 1) {
      result += characters.charAt(Math.floor(Math.random() * characters.length));
    }

    return result;
  }

  function createUUID() {
    var cryptoObj = global.crypto || global.msCrypto;
    if (cryptoObj && typeof cryptoObj.randomUUID === "function") {
      return cryptoObj.randomUUID();
    }

    return makeId();
  }

  function serializeError(err) {
    if (err instanceof Error) {
      return {
        name: err.name,
        message: err.message,
        stack: err.stack,
      };
    }

    if (typeof err === "object" && err !== null) {
      var copy = {};
      var key;
      for (key in err) {
        if (Object.prototype.hasOwnProperty.call(err, key)) {
          copy[key] = err[key];
        }
      }
      return copy;
    }

    return {
      message: String(err == null ? "Unknown error" : err),
    };
  }

  function extractVersion(ua, regex) {
    var match = ua.match(regex);
    return match && match[1] ? match[1] : "";
  }

  function majorFromVersion(version) {
    if (!version) {
      return "";
    }

    return String(version).split(".")[0] || "";
  }

  function parseUserAgent() {
    var ua = (global.navigator && global.navigator.userAgent) || "";
    var platform = (global.navigator && global.navigator.platform) || "";

    var browserName = "";
    var browserVersion = "";

    if (/Edg\//.test(ua)) {
      browserName = "Edge";
      browserVersion = extractVersion(ua, /Edg\/([\d.]+)/);
    } else if (/OPR\//.test(ua)) {
      browserName = "Opera";
      browserVersion = extractVersion(ua, /OPR\/([\d.]+)/);
    } else if (/Chrome\//.test(ua)) {
      browserName = "Chrome";
      browserVersion = extractVersion(ua, /Chrome\/([\d.]+)/);
    } else if (/Firefox\//.test(ua)) {
      browserName = "Firefox";
      browserVersion = extractVersion(ua, /Firefox\/([\d.]+)/);
    } else if (/Safari\//.test(ua) && /Version\//.test(ua)) {
      browserName = "Safari";
      browserVersion = extractVersion(ua, /Version\/([\d.]+)/);
    }

    var osName = "";
    if (/Windows NT/.test(ua)) {
      osName = "Windows";
    } else if (/Android/.test(ua)) {
      osName = "Android";
    } else if (/iPhone|iPad|iPod/.test(ua)) {
      osName = "iOS";
    } else if (/Mac OS X/.test(ua)) {
      osName = "macOS";
    } else if (/Linux/.test(ua)) {
      osName = "Linux";
    }

    var engineName = "";
    var engineVersion = "";
    if (/AppleWebKit\//.test(ua)) {
      engineName = "WebKit";
      engineVersion = extractVersion(ua, /AppleWebKit\/([\d.]+)/);
    }
    if (/Gecko\//.test(ua) && /Firefox\//.test(ua)) {
      engineName = "Gecko";
      engineVersion = extractVersion(ua, /rv:([\d.]+)/);
    }
    if (/Chrome\//.test(ua) || /Edg\//.test(ua) || /OPR\//.test(ua)) {
      engineName = "Blink";
      engineVersion = extractVersion(ua, /Chrome\/([\d.]+)/);
    }

    var architecture = "";
    if (/arm|aarch64/i.test(ua) || /arm/i.test(platform)) {
      architecture = "arm";
    } else if (/x86_64|Win64|x64|amd64|Intel/i.test(ua + " " + platform)) {
      architecture = "amd64";
    }

    var deviceType = "";
    if (/iPad|Tablet|PlayBook|Silk/i.test(ua)) {
      deviceType = "tablet";
    } else if (/Mobile|iPhone|Android/i.test(ua)) {
      deviceType = "mobile";
    } else if (ua) {
      deviceType = "desktop";
    }

    return {
      browser: {
        major: majorFromVersion(browserVersion),
        name: browserName,
        version: browserVersion,
      },
      os: {
        name: osName,
      },
      engine: {
        name: engineName,
        version: engineVersion,
      },
      cpu: {
        architecture: architecture,
      },
      device: {
        type: deviceType,
      },
    };
  }

  /**
   * Logger service that captures client events and sends them to backend.
   */
  function LoggerService(opts) {
    var input = opts || {};
    this.backendURL = "https://designer-backend-ecs.smwd.tools"
    this.captureEvents = new Set(input.captureEvents || []);
    this.captureLevels = new Set(input.captureLevels || []);
    this.alwaysCaptureLevels = new Set(input.alwaysCaptureLevels || ["error"]);
    this.info = parseUserAgent();
    this.appVersion = input.appVersion || global.SMWD_APP_VERSION || "";
    this.isStarted = false;

    this.handleBrowserLogEvent = this.handleBrowserLogEvent.bind(this);
    this.handleWindowError = this.handleWindowError.bind(this);
    this.handleUnhandledRejection = this.handleUnhandledRejection.bind(this);

    this.initializeIds();
  }

  LoggerService.prototype.initializeIds = function initializeIds() {
    try {
      var currentUserID = global.localStorage.getItem(LOGGER_USER_ID_KEY);

      if (!currentUserID || currentUserID === "null" || currentUserID === "undefined") {
        global.localStorage.setItem(LOGGER_USER_ID_KEY, createUUID());
      }

      var currentSessionID = global.sessionStorage.getItem(LOGGER_SESSION_ID_KEY);
      if (!currentSessionID || currentSessionID === "null" || currentSessionID === "undefined") {
        global.sessionStorage.setItem(LOGGER_SESSION_ID_KEY, createUUID());
      }
      
      
    } catch (err) {
      console.warn("Failed to initialize logger IDs:", err);
    }
  };

  LoggerService.prototype.start = function start() {
    // Dont run if we're in customs app, let app handle it
    if(location.pathname.includes("pages/app") || location.pathname.includes("pages/dev-designer")){
        return;
    }

    if (this.isStarted || !global.addEventListener) {
      return;
    }

    global.addEventListener(LOGGER_EVENT_NAME, this.handleBrowserLogEvent);
    global.addEventListener("unhandledrejection", this.handleUnhandledRejection);
    this.isStarted = true;
  };

  LoggerService.prototype.stop = function stop() {
    if (!this.isStarted || !global.removeEventListener) {
      return;
    }

    global.removeEventListener(LOGGER_EVENT_NAME, this.handleBrowserLogEvent);
    global.removeEventListener("unhandledrejection", this.handleUnhandledRejection);
    this.isStarted = false;
  };

  LoggerService.prototype.handleBrowserLogEvent = async function handleBrowserLogEvent(evt) {
    var log = this.createLog(evt && evt.detail ? evt.detail : {});

    if (!this.shouldCapture(log)) {
      return;
    }

    await this.upload(log);
  };

  LoggerService.prototype.handleWindowError = async function handleWindowError(evt) {
    var log = this.createLog({
      LogLevel: "error",
      Event: "window-error",
      Data: {
        message: evt && evt.message,
        source: evt && evt.filename,
        line: evt && evt.lineno,
        column: evt && evt.colno,
        error: serializeError(evt && evt.error),
      },
    });

    await this.upload(log);
  };

  LoggerService.prototype.handleUnhandledRejection = async function handleUnhandledRejection(evt) {
    var log = this.createLog({
      LogLevel: "error",
      Event: "unhandled-rejection",
      Data: {
        reason: serializeError(evt && evt.reason),
      },
    });

    await this.upload(log);
  };

  LoggerService.prototype.parseSmwdParams = function parseSmwdParams(){
    const searchParams = new URLSearchParams(window.location.search);
    const creativeSource =
      searchParams.get("creativeSource") ??
      searchParams.get("smwdCreativeSource") ??
      "";
    const creativeID =
      searchParams.get("creativeID") ??
      searchParams.get("smwdCreativeID") ??
      "";

    const smwdParams = {
      creativeSource,
      creativeID,
    };

    return smwdParams;
  }

  LoggerService.prototype.createLog = function createLog(data) {
    var payload = data || {};
    var normalizedLogLevel = payload.logLevel || payload.LogLevel || "info";
    var normalizedEvent = payload.event || payload.Event || "unknown-event";
    var normalizedData =
      payload.data !== undefined ? payload.data : payload.Data !== undefined ? payload.Data : {};

    return new Log({
      userID: (global.localStorage && global.localStorage.getItem(LOGGER_USER_ID_KEY)) || "",
      sessionID:
        (global.sessionStorage && global.sessionStorage.getItem(LOGGER_SESSION_ID_KEY)) || "",
      logLevel: normalizedLogLevel,
      event: normalizedEvent,
      createdAt: Date.now(),
      page: (global.location && global.location.pathname) || "",
      urlParams: (global.location && global.location.search) || "",
      platform: (global.navigator && global.navigator.platform) || "",
      messageType: "log",
      appVersion: this.appVersion,
      browser: new Browser(this.info.browser),
      os: new OS(this.info.os),
      engine: new Engine(this.info.engine),
      cpu: new CPU(this.info.cpu),
      device: new Device(this.info.device),
      data: this.normalizeData(normalizedData),
      smwdParams: this.parseSmwdParams(),
    });
  };

  LoggerService.prototype.normalizeData = function normalizeData(data) {
    if (data === null || data === undefined) {
      return {};
    }

    if (data instanceof Error) {
      return serializeError(data);
    }

    if (Array.isArray(data) || typeof data === "object" || typeof data === "string") {
      return data;
    }

    return { value: data };
  };

  LoggerService.prototype.shouldCapture = function shouldCapture(log) {
    if (this.alwaysCaptureLevels.has(log.logLevel)) {
      return true;
    }

    var levelFilterEnabled = this.captureLevels.size > 0;
    var eventFilterEnabled = this.captureEvents.size > 0;

    if (!levelFilterEnabled && !eventFilterEnabled) {
      return true;
    }

    if (levelFilterEnabled && this.captureLevels.has(log.logLevel)) {
      return true;
    }

    if (eventFilterEnabled && this.captureEvents.has(log.event)) {
      return true;
    }

    return false;
  };

  LoggerService.prototype.upload = async function upload(log) {
    if (!this.backendURL || typeof global.fetch !== "function") {
      return;
    }

    // Sanity check to really make sure we don't fire any events while inside customs app
    if(location.pathname.includes("pages/app") || location.pathname.includes("pages/dev-designer")){
      return;
    }

    try {
      // console.log("Shopify send log:", log);

      // navigator.sendBeacon?.(this.backendURL + "/doc/log", JSON.stringify(log)) ||
      // fetch(this.backendURL + "/doc/log", {
      //   method: 'POST',
      //   headers: { 'Content-Type': 'application/json' },
      //   body: JSON.stringify(log),
      //   keepalive: true
      // }).catch(() => {});

      var response = await global.fetch(this.backendURL + "/doc/log", {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(log),
      });

      if (!response.ok) {
        console.warn("Failed to post log:", response.status, response.statusText);
      }
    } catch (err) {
      console.warn("Failed to post log:", err);
    }
  };

  function postLogEvent(data) {
    if (!global || typeof global.dispatchEvent !== "function") {
      return;
    }

    global.dispatchEvent(
      new CustomEvent(LOGGER_EVENT_NAME, {
        detail: data || {},
      }),
    );
  }
  

  var loggerService = new LoggerService();

  if (global && typeof global.addEventListener === "function") {
    loggerService.start();
  }

  global.SMWDLogger = {
    LOGGER_EVENT_NAME: LOGGER_EVENT_NAME,
    Browser: Browser,
    OS: OS,
    Device: Device,
    Engine: Engine,
    CPU: CPU,
    Log: Log,
    LoggerService: LoggerService,
    loggerService: loggerService,
    postLogEvent: postLogEvent,
  };

	function firePageLoadEvent() {
    if(location.pathname.includes("pages/app") || location.pathname.includes("pages/dev-designer")){
      return
    } else {
      SMWDLogger.postLogEvent({
        event: "page-load",
        logLevel: "nav",
        data: {
          url: window.location.href,
          path: window.location.pathname,
          referrer: document.referrer || null,
          loadTime: performance.now()
        }
      });
    }
	}

	if (document.readyState === "complete") {
		firePageLoadEvent();
	} else {
		window.addEventListener("load", firePageLoadEvent);
	}

	window.addEventListener("popstate", firePageLoadEvent);
	document.addEventListener("shopify:section:load", firePageLoadEvent);
})(typeof window !== "undefined" ? window : this);

